import { SignInErrorCodeV1, SignInErrorV1 } from '@vista-digital/ocapi-client';
import { MemberAuthenticationGrantType } from '@vista-digital/ocapi-types/v1';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { LoyaltyAuthenticationType } from '../../../../../configuration/types/loyalty/loyalty-authentication-type';
import { CommonErrorCodes } from '../../../../../types/errors';
import { logger } from '../../../../../utils/logger';
import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../../../types/error';
import { signMemberOut } from './sign-member-out';
import { updateIsMemberSignedInFromToken } from './update-is-member-signed-in-from-token';
/**
 * Refresh the [[MemberAuthenticationToken]] of a previously signed in member using the old token.
 * If the token fails to refresh the stored token is reset and the member is signed out.
 */
export const refreshMemberAuthenticationToken = async (oldToken) => {
    const { authentication } = configurationSettings.data.loyalty;
    if (authentication.type !== LoyaltyAuthenticationType.Token) {
        throw new Error('Cannot refresh token when API configuration is not set to LoyaltyAuthenticationType.Token');
    }
    try {
        const newToken = await getNewToken(oldToken);
        await updateIsMemberSignedInFromToken(newToken);
        return newToken;
    }
    catch (error) {
        logger.warn('Failed to refresh authentication token, member must sign in again.', error);
        await authentication.setToken(undefined);
        await signMemberOut();
    }
};
const getNewToken = async (oldToken) => {
    try {
        return await ocapiClient.instance.v1.loyalty.members.authentication.createToken({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            grant_type: MemberAuthenticationGrantType.RefreshToken,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            refresh_token: oldToken.refresh_token
        }, undefined);
    }
    catch (error) {
        throw handleApiError(error);
    }
};
const handleApiError = (error) => {
    if (!(error instanceof SignInErrorV1))
        throw error; // Unexpected error, rethrow immediately
    const errorCode = convertApiToDomainErrorCode(error.errorCode);
    throw new LoyaltyDomainError(errorCode, error.message);
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case SignInErrorCodeV1.MemberLocked:
            return LoyaltyDomainSpecificErrorCode.MemberLocked;
        case SignInErrorCodeV1.RefreshTokenExpired:
            return LoyaltyDomainSpecificErrorCode.RefreshTokenExpired;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
